/**
 * A no-operation function.
 * Useful when an empty function is required by an API or component,
 * but you want to avoid ESLint warnings or accidental use.
 */
export const noop = () => {
	// intentionally left blank
};
